<template>
  <div class="container">
    <van-list
      v-model="listloading"
      :immediate-check="false"
      :finished="listfinished"
      finished-text="没有更多啦"
      @load="listload_more()"
    >
      <div
        v-for="item in list"
        :key="item.id"
        class="list"
        @click="linketo(item.id, item.type, item.link)"
      >
        <div class="left">
          <img :src="item.img" alt="" />
        </div>
        <div class="right">
          <div class="flex" style="width: 100%">
            <span class="title">#{{ item.tag }}#</span>
            <div class="flex">
              <img
                src="//pic-cdn.bigdatajy.com/wenming/static/img/book.png"
                class="book"
                alt=""
              />
              <span>{{ item.read }}</span>
            </div>
          </div>
          <p class="info">{{ item.title }}</p>
          <p class="unit">{{ item.org_name }}</p>
          <p class="date">{{ item.post_date }}</p>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "resentzx",
  data() {
    return {
      list: [],
      listloading: false,
      listfinished: false,
      listpage: 1,
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/news/list",
      data: this.qs.stringify({
        org_id: this.$route.query.id,
      }),
    }).then((res) => {
      console.log(res.data);
      this.list = res.data.data.list;
    });
  },
  methods: {
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/news/list",
            data: that.qs.stringify({
              page: that.listpage,
              org_id: that.$route.query.id,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
    linketo(id, type, url) {
      if (type == 1) {
        this.$router.push({
          name: "newsdetail",
          query: {
            id: id,
          },
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/news/click",
          data: this.qs.stringify({
            id: id,
            zjy_uid: sessionStorage.getItem("uid"),
          }),
        }).then((res) => {
          console.log(res.data);
          location.href = url;
        });
      }
    },
  },
};
</script>
<style scoped>
.list {
  display: flex;
  margin-bottom: 10px;
  height: 80px;
  justify-content: space-between;
  padding: 0 10px;
}
.list .left {
  width: 33%;
}
.list .left img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.list .right {
  width: 64%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.book {
  height: 20px;
  width: auto;
}
.date,
.unit,
.title {
  font-size: 14px;
}
.date {
  color: grey;
  text-align: right;
}
.unit {
  text-align: right;
}
.title {
  color: blue;
}
</style>


// WEBPACK FOOTER //
// src/components/resentzx.vue